module.exports = __webpack_public_path__ + "static/img/m_modify.7ef1fff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/m_modify.png
// module id = MI8O
// module chunks = 9